import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { ADVISING_REPORT_STATUSES } from 'src/services/mappings/advisingReport/advisingReport.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const advisingReportFields: FieldInterface[] = [
  {
    key: 'name',
    originKey: 'name',
    type: FIELD_TYPES.string,
  },
  {
    key: 'url',
    originKey: 'url',
    type: FIELD_TYPES.string,
  },
  {
    key: 'kind',
    originKey: 'kind',
    type: FIELD_TYPES.string,
    enumKeys: [],
  },
  {
    key: 'clientId',
    originKey: 'client_id',
    type: FIELD_TYPES.string,
  },
  {
    key: 'status',
    originKey: 'status',
    type: FIELD_TYPES.string,
    enumKeys: Object.values(ADVISING_REPORT_STATUSES),
  },
]

const advisingReportRelations: RelationInterface[] = []

export { advisingReportFields, advisingReportRelations }
